import { compact } from "lodash";
import { getFetchedContacts } from "../../redux/contact/contact.selectors";
export var customGetForeignerContactsForAccountIds = function (state, accountIds) {
    var contacts = getFetchedContacts(state);
    var resultRaw = accountIds.map(function (accountId) {
        var contact = contacts.find(function (contact) {
            return contact.accountIds.includes(accountId);
        });
        if (!contact) {
            return undefined;
        }
        var hasNationalRegisterNumber = !!contact.nationalRegisterNumber;
        if (hasNationalRegisterNumber) {
            return undefined;
        }
        return contact;
    });
    return compact(resultRaw);
};
